import React, { useState,useEffect } from "react";
import axios from "axios";
import { Link, useNavigate} from "react-router-dom";
import Members from "../components/common/MembersCard";
import HomeComplaintStatus from "../components/common/HomeComplaintStatus";
import { getAllCategories } from "../services/photoCategoryService";
import { getAllVideos } from "../services/videoService";
import { FILE_BASE_URL } from "../utils/constants";

export default function Home() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllCategories().then((data) => {
      const latestThree = [...data]
        .sort((a, b) => b.id - a.id)
        .slice(0, 3);

      setCategories(latestThree);
    });
  }, []);

  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const data = await getAllVideos();

        // ✅ latest 3 videos only
        const latestThree = [...data]
          .sort((a, b) => b.id - a.id)
          .slice(0, 3);

        setVideos(latestThree);
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    };

    fetchVideos();
  }, []);

  const getYoutubeId = (url) => {
    const urlObj = new URL(url);
    return urlObj.searchParams.get("v");
  };

  return (
    <div>
      <>  
      
        {/* Carousel Start */}     
        <div className="container-fluid p-0 mb-5 wow fadeIn" data-wow-delay="0.1s">
  <div
    id="header-carousel"
    className="carousel slide"
    data-bs-ride="carousel"
  >

    {/* INDICATORS */}
    <div className="carousel-indicators">
      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={0}
        className="active"
        aria-current="true"
        aria-label="Slide 1"
      >
        <img className="img-fluid" src="/assests/img/members/bscpcr_banner_01.jpg" alt="Image" />
      </button>

      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={1}
        aria-label="Slide 2"
      >
        <img className="img-fluid" src="/assests/img/members/banner_03.png" alt="Image" />
      </button>

      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={2}
        aria-label="Slide 3"
      >
        <img className="img-fluid" src="/assests/img/members/bscpcr_banner_02.jpg" alt="Image" />
      </button>

      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={3}
        aria-label="Slide 4"
      >
        <img className="img-fluid" src="/assests/img/members/banner_01.png" alt="Image" />
      </button>

      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={4}
        aria-label="Slide 5"
      >
        <img className="img-fluid" src="/assests/img/members/bscpcr_banner_03.jpg" alt="Image" />
      </button>

      <button
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide-to={5}
        aria-label="Slide 6"
      >
        <img className="img-fluid" src="/assests/img/members/bscpcr_banner_04.jpg" alt="Image" />
      </button>
    </div>

    {/* SLIDES */}
    <div className="carousel-inner">
      <div className="carousel-item active">
        <img className="w-100 img-fluid" src="/assests/img/members/bscpcr_banner_01.jpg" alt="Image" />
      </div>

      <div className="carousel-item">
        <img className="w-100 img-fluid" src="/assests/img/members/banner_03.png" alt="Image" />
      </div>

      <div className="carousel-item">
        <img className="w-100 img-fluid" src="/assests/img/members/bscpcr_banner_02.jpg" alt="Image" />
      </div>

      <div className="carousel-item">
        <img className="w-100 img-fluid" src="/assests/img/members/banner_01.png" alt="Image" />
      </div>

      <div className="carousel-item">
        <img className="w-100 img-fluid" src="/assests/img/members/bscpcr_banner_03.jpg" alt="Image" />
      </div>

      <div className="carousel-item">
        <img className="w-100 img-fluid" src="/assests/img/members/bscpcr_banner_04.jpg" alt="Image" />
      </div>
    </div>

    {/* CONTROLS */}
    <button
      className="carousel-control-prev"
      type="button"
      data-bs-target="#header-carousel"
      data-bs-slide="prev"
    >
      <span className="carousel-control-prev-icon" aria-hidden="true" />
      <span className="visually-hidden">Previous</span>
    </button>

    <button
      className="carousel-control-next"
      type="button"
      data-bs-target="#header-carousel"
      data-bs-slide="next"
    >
      <span className="carousel-control-next-icon" aria-hidden="true" />
      <span className="visually-hidden">Next</span>
    </button>

  </div>
        </div>
        {/* Carousel End */}

        {/* About Start */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="img-border">
                  <img className="img-fluid" src="/assests/img/about.jpg" alt="" />
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <div className="h-100">
                 <h6 className="section-title bg-white text-start text-primary pe-3">
                  About Us 
                </h6>
                  <h1 className="display-6 mb-4">
            बिहार{" "}
            <span className="text-primary"> बाल अधिकार </span>
            संरक्षण आयोग
          </h1>

          <p className="text-justify">
            देश में बाल अधिकार एवं संरक्षण से संबंधित कई कानून समय-समय पर बनाए और संशोधित किए गए हैं।
            2005 में बाल अधिकार संरक्षण आयोग अधिनियम पारित हुआ, जिसके तहत 2007 में राष्ट्रीय बाल अधिकार
            संरक्षण आयोग का गठन किया गया।
          </p>

          <p className="mb-4 text-justify">
            इसी अधिनियम की धारा 17 के अंतर्गत राज्यों में आयोग गठित करने का प्रावधान किया गया,
            जिसके क्रम में 30 अगस्त 2010 को बिहार राज्य बाल अधिकार संरक्षण आयोग का गठन किया गया।
            आयोग का मुख्य उद्देश्य बाल अधिकारों की रक्षा, निगरानी एवं संवर्धन करना है।
          </p>
            <Link className="btn btn-primary rounded-pill py-3 px-5" to="/about">
            Read More
          </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* About End */}


        {/* e-Baladhikar Section Start */}
        <div className="container-xxl py-5">
          <div className="container">
            {/* Section Header */}
            <div
              className="text-center mx-auto mb-5 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ maxWidth: "650px" }}
            >
              <h6 className="section-title bg-white text-center text-primary px-3">
                eBaal Adhikar
              </h6>
             
            </div>

            {/* Cards Row */}
            <div className="row g-4 justify-content-center">
             

<div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
  <div className="card h-100 shadow-lg border-0 rounded-4">
    <div className="card-body text-center p-4 d-flex flex-column">
 <h4 className="text-primary mb-3 fw-bold">
          Register Complaint
        </h4>
      <section id="register-complaint" className="bg-light py-5 rounded-3 d-flex flex-column justify-content-between flex-grow-1">
       

        <p className="mb-4 text-muted lh-sm">
          Lodge a complaint related to child rights, protection, or welfare.
        </p>

        {/* Redirect Button */}
        <Link
          to="/RegisterComplaint"
          className="btn btn-primary rounded-pill fw-semibold home-action-btn align-self-center"
        >
          <i className="fa fa-edit me-2"></i>
          Register Complaint
        </Link>
      </section>

    </div>
  </div>
</div>

              
               {/* Complaint Status */}
              <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="card h-100 shadow-lg border-0 rounded-4">
                  
                  <div className="card-body text-center p-4 d-flex flex-column">
                    <h4 className="text-primary mb-3 fw-bold">Track Complaint</h4>
                    <section id="complaint-status" className="bg-light py-5 rounded-3 d-flex flex-column flex-grow-1">
                      <HomeComplaintStatus />
                    </section>
                  </div>
                </div>
              </div>


             {/* Contact Us */}
<div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
  <div className="card h-100 shadow-lg border-0 rounded-4">
    <div className="card-body text-center p-4 d-flex flex-column">
      <h4 className="text-primary mb-3 fw-bold">Write to Us</h4>

      <div id="write-us-panel" className="bg-light p-4 rounded-3 border d-flex flex-column flex-grow-1">
        <p className="mb-2 fw-semibold">
          For any queries or support, please write to us at:
        </p>

        <p className="mb-4">
          <i className="fa fa-envelope text-primary me-2"></i>
          <strong>scpcr.bihar@gmail.com</strong>
        </p>
<br/>
        {/* Mail Button */}
        <Link
          to="mailto:support@biharscpcr.in"
          className="btn btn-primary rounded-pill fw-semibold home-action-btn align-self-center"
        >
          <i className="fa fa-paper-plane me-2"></i>
          Send Email
        </Link>
      </div>
    </div>
  </div>
</div>

            </div>
          </div>
        </div>
        {/* e-Baladhikar End */}
        <style>{`
          #register-complaint,
          #complaint-status,
          #write-us-panel {
            min-height: 250px;
          }
          .home-action-btn {
            width: 210px;
            height: 42px !important;
            min-height: 42px !important;
            max-height: 42px !important;
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            padding: 0 !important;
            font-size: 0.95rem;
            line-height: 1.2;
            box-sizing: border-box;
            text-decoration: none !important;
            border-width: 1px !important;
            appearance: none;
            -webkit-appearance: none;
          }
          .home-action-btn i {
            line-height: 1;
            font-size: 14px;
          }
          a.home-action-btn-mail {
            height: 42px !important;
            min-height: 42px !important;
            max-height: 42px !important;
            line-height: 1 !important;
          }
        `}</style>


        {/* Social Media Start */}
        <div className="container-xxl py-5">
          <div className="container">
            {/* Section Header */}
            <div
              className="text-center mx-auto mb-5 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ maxWidth: "600px" }}
            >
              <h6 className="section-title bg-white text-center text-primary px-3">
                BSCPCR @ SOCIAL MEDIA
              </h6>
           
            </div>

            {/* Social Media Cards */}
            <div className="row g-4">
              {/* Facebook */}
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <a
                  href="https://www.facebook.com/biharscpcr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center bg-white rounded-4 shadow-sm p-4 h-100 social-card"
                >
                  <div
                    className="icon mb-3 mx-auto d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#1877F2",
                    }}
                  >
                    <i className="fab fa-facebook-f fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-1">Facebook</h5>
                  <p className="text-muted mb-0">Join our community</p>
                </a>
              </div>

              {/* Twitter / X */}
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                <a
                  href="https://x.com/BiharSCPCR"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center bg-white rounded-4 shadow-sm p-4 h-100 social-card"
                >
                  <div
                    className="icon mb-3 mx-auto d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#000000",
                    }}
                  >
                    <i className="fab fa-twitter fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-1">Twitter / X</h5>
                  <p className="text-muted mb-0">Get our latest updates</p>
                </a>
              </div>

              {/* Instagram */}
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <a
                  href="https://www.instagram.com/biharscpcr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center bg-white rounded-4 shadow-sm p-4 h-100 social-card"
                >
                  <div
                    className="icon mb-3 mx-auto d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      background:
                        "radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
                    }}
                  >
                    <i className="fab fa-instagram fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-1">Instagram</h5>
                  <p className="text-muted mb-0">See our latest moments</p>
                </a>
              </div>

              {/* YouTube */}
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                <a
                  href="https://www.youtube.com/@biharscpcr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center bg-white rounded-4 shadow-sm p-4 h-100 social-card"
                >
                  <div
                    className="icon mb-3 mx-auto d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#FF0000",
                    }}
                  >
                    <i className="fab fa-youtube fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-1">YouTube</h5>
                  <p className="text-muted mb-0">Watch our awareness videos</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media End */}

        {/* Members Start */}
        <Members />
        {/* Member End */}

      {/* Video Section Start */}
      <div className="container-xxl py-5">
        <div className="container">

          {/* Section Header */}
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="section-title bg-white text-center text-primary px-3 rounded-pill shadow-sm">
              BSCPCR Video Gallery
            </h6>
          </div>

          {/* Video Grid */}
          <div className="row g-4">
            {videos.map((video, index) => (
              <div
                key={video.id}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + index * 0.2}s`}
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedVideo(video)}
              >
                <div className="card border-0 shadow-sm rounded-4 h-100 video-card">
                  <div className="ratio ratio-16x9 rounded-top overflow-hidden">
                    <img
                      src={`https://img.youtube.com/vi/${getYoutubeId(
                        video.videoUrl
                      )}/hqdefault.jpg`}
                      alt={video.title}
                      className="img-fluid"
                      style={{ objectFit: "cover" }}
                    />
                  </div>

                  <div className="card-body text-center p-3">
                    <h5 className="fw-semibold text-dark">
                      {video.title}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View More Button */}
          <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.6s">
            <button
              className="btn btn-primary rounded-pill py-3 px-5 fw-semibold shadow-sm"
              onClick={() => navigate("/videos")}
            >
              View More Videos
            </button>
          </div>
        </div>
      </div>
      {/* Video Section End */}

      {/* Video Modal */}
      {selectedVideo && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          onClick={() => setSelectedVideo(null)}
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content rounded-4 overflow-hidden">
              <div className="modal-header">
                <h5 className="modal-title">{selectedVideo.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedVideo(null)}
                ></button>
              </div>
              <div className="modal-body p-0">
                <iframe
                  width="100%"
                  height="400"
                  src={`https://www.youtube.com/embed/${getYoutubeId(
                    selectedVideo.videoUrl
                  )}`}
                  title={selectedVideo.title}
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}

        {/* Video End */}

        {/* Photos Section Start */}
      <div className="container-xxl py-5">
        <div className="container">

          {/* Section Header */}
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="section-title bg-white text-center text-primary px-3 d-inline-block rounded-pill shadow-sm">
              BSCPCR Photo Gallery
            </h6>
          </div>

          {/* Category Grid */}
          <div className="row g-4">
            {categories.map((c, index) => (
              <div
                key={c.id}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + index * 0.1}s`}
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/gallery/${c.id}`)}
              >
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 gallery-card">
                  <img
                    src={
                      c?.photoUrl?.startsWith("http")
                        ? c.photoUrl
                        : `${FILE_BASE_URL.replace(/\/$/, "")}/${String(c.photoUrl || "").replace(/^\//, "")}`
                    }
                    className="img-fluid w-100"
                    alt={c.name}
                    style={{ height: "260px", objectFit: "cover" }}
                  />

                  <div className="card-body text-center">
                    <h5 className="fw-semibold mb-0">{c.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View More Button */}
          <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.5s">
            <Link
              to="/category"
              className="btn btn-outline-primary rounded-pill py-3 px-5 fw-semibold shadow-sm"
            >
              View More Photos
            </Link>
          </div>

        </div>
      </div>
      {/* Photos Section End */}

      </>

    </div>
  )
}
